<main *ngIf="form">
    <div class="l-container l-container--l" *ngIf="currentSeite">
        <h1>{{currentSeite.seiteDefinition.label}}</h1>
    </div>

    <div class="l-container l-container--m">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div>

                <div *ngIf="currentSeite">
                    <div *ngFor="let element of currentSeite.elemente">

                        <form-element-selector
                            [element]="element"
                            [visible]="isVisible(element)"
                            [form]="form"
                            [submitted]="getSubmitted()">
                        </form-element-selector>

                    </div>
                </div>
            </div>
        </form>
    </div>
    <vhv-footer
        (next)="onSubmit()"
        [show-back]="currentSeite && !currentSeite.isStartSeite()"
        [next-disabled]="!areControlsValid"
        [page-reused]="isPageReused"></vhv-footer>
</main>
